import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export const ProductDetailsSizeNotFound = () => (
	<Box
		sx={{
			width: '100%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			padding: { xs: '24px', sm: '48px' },
			border: { xs: '1px solid #E0E0E0', sm: 'none' },
			borderRadius: '8px',
			backgroundColor: '#F9F9F9',
		}}
	>
		<InfoIcon
			sx={{
				fontSize: { xs: '40px', sm: '48px' },
				color: 'primary.main',
			}}
		/>
		<Typography
			sx={{
				fontSize: { xs: '20px', sm: '24px' },
				fontWeight: 'bold',
				marginBottom: '12px',
				textAlign: 'center',
				letterSpacing: '0.15px',
			}}
		>
			{'¡Ups! Sin una guía de tallas disponible'}
		</Typography>
		<Typography
			sx={{
				fontSize: { xs: '14px', sm: '16px' },
				textAlign: 'center',
				letterSpacing: '0.15px',
			}}
		>
			{'Pero no te preocupes, estamos trabajando para ofrecerte la mejor experiencia.'}
		</Typography>
	</Box>
);
